<template>
    <div>
        <div class="main-content">
            <div class="gradebook">
                <div class="row-center">
                    <div class="title">Gradebook</div>
                    <img :src="closeImg" style="width: 40px;height: 40px;" alt="Close" @click="goBack()">
                </div>
                <hr style="margin: 16px 0" />
                <div class="toottip-wrapper">
                    <table class="table-course-info">
                        <thead>
                            <tr>
                                <th>Course name</th>
                                <th>Current score</th>
                                <th>Course score</th>
                                <th>Component grades</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="ellipsis" ref="textEl" @mouseenter="showCourseNameTooltip = isEllipsis"
                                    @mouseleave="showCourseNameTooltip = false">
                                    {{ courseGradebookData.course_name }}
                                    <div v-if="showCourseNameTooltip" class="tooltip">
                                        {{ courseGradebookData.course_name }}
                                    </div>
                                </td>
                                <td>
                                    {{ courseGradebookData.current_grade }}%
                                    {{ courseGradebookData.current_grade_letter ?
                                        `(${courseGradebookData.current_grade_letter})` : '' }}
                                </td>
                                <td>
                                    {{ courseGradebookData.course_grade }}%
                                    {{ courseGradebookData.course_grade_letter ?
                                        `(${courseGradebookData.course_grade_letter})` : '' }}
                                </td>
                                <td>
                                    <img class="icon" :src="gradebookImg" alt="" @click="openComponentModal()" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div style="overflow: auto;padding-right: 8px;">
                <div class="score-activity-row row-center">
                    <div class="title">Scores of activities </div>
                    <div class="search-bar">
                        <input type="text" placeholder="Search anything" v-model="searchText" @keyup.enter="onSearch" />
                        <button class="search-btn" :disabled="searchText == ''" @click="onSearch">
                            <img class="icon" :src="searchImg" alt="" />
                        </button>
                    </div>
                </div>
                <div class="score-table">
                    <table>
                        <colgroup>
                            <col :style="{ width: colWidths[0] }" />
                            <col :style="{ width: colWidths[1] }" />
                            <col :style="{ width: colWidths[2] }" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>Group of activities</th>
                                <th>Activity</th>
                                <th class="row-center" style="justify-content: center">
                                    Final score
                                    <div ref="tooltipWrapper" @mouseenter="handleMouseEnter"
                                        @mouseleave="handleMouseLeave" @click.stop="handleClick">
                                        <img :src="infoImg" alt="" style="margin-left: 16px; cursor: pointer;" />
                                        <div v-if="showTooltip" class="tooltip-box" :style="tooltipStyle">
                                            <div v-for="(item, index) in tooltipItems" :key="index"
                                                class="tooltip-item row-center">
                                                <div style="min-width: 30%;">
                                                    <span v-if="item.type === 'score'" :class="item.color">
                                                        {{ item.value }}
                                                    </span>
                                                    <img v-else :src="item.icon" class="icon" alt="" />
                                                </div>
                                                <span class="desc">{{ item.desc }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="(lstModules?.length || lstSemesterTest?.length || participant?.length)">
                                <template v-if="lstModules?.length" v-for="(module, gIndex) in lstModules">
                                    <!-- First row: group name + activity[0] -->
                                    <tr :key="'group-' + gIndex"
                                        :class="{ 'highlight-group': hoveredGroup === gIndex }">
                                        <td :rowspan="module.activities.length" class="group-name"
                                            @mouseenter="hoveredGroup = gIndex" @mouseleave="hoveredGroup = null">
                                            {{ module.module_name }}
                                        </td>
                                        <td class="activiti-name" @mouseenter="hoveredActivity = gIndex + '-0'"
                                            @mouseleave="hoveredActivity = null"
                                            :class="{ 'highlight-activity underline': hoveredActivity === gIndex + '-0' }"
                                            @click="handleNavigate(module.activities[0].navigation_detail)">
                                            {{ module.activities[0].activity_name }}
                                        </td>
                                        <td @mouseenter="hoveredActivity = gIndex + '-0'"
                                            @mouseleave="hoveredActivity = null" class="score"
                                            :class="[scoreClass(module.activities[0].weight != null), { 'highlight-activity': hoveredActivity === gIndex + '-0' }]"
                                            @click="handleNavigate(module.activities[0].navigation_detail)">
                                            <div class="row-center" style="justify-content: center;padding: 0 4px;">
                                                <div style="width: 60%;">
                                                    {{
                                                        formatScore(module.activities[0].current_score_view,
                                                            module.activities[0].current_score)
                                                    }}
                                                </div>
                                                <div class="icon-row">
                                                    <img class="icon"
                                                        v-show="module.activities[0].navigation_detail.status == 'NeedToResubmit'"
                                                        :src="redoImg" alt="" />
                                                    <img class="icon"
                                                        v-show="(module.activities[0].navigation_detail.status == 'NeedToResubmit' || module.activities[0].navigation_detail.status == 'Completed') && module.activities[0].navigation_detail.has_feedback"
                                                        :src="cmtImg" alt="" />
                                                </div>
                                            </div>
                                        </td>
                                    </tr>

                                    <!-- Other activities -->
                                    <tr v-for="(activity, aIndex) in module.activities.slice(1)"
                                        :key="'activity-' + gIndex + `-${aIndex}`"
                                        :class="{ 'highlight-group': hoveredGroup === gIndex }"
                                        @click="handleNavigate(activity.navigation_detail)">
                                        <td class="activiti-name"
                                            @mouseenter="hoveredActivity = gIndex + `-${aIndex + 1}`"
                                            @mouseleave="hoveredActivity = null"
                                            :class="{ 'highlight-activity underline': hoveredActivity === gIndex + `-${aIndex + 1}` }">
                                            {{ activity.activity_name }}
                                        </td>
                                        <td @mouseenter="hoveredActivity = gIndex + `-${aIndex + 1}`"
                                            @mouseleave="hoveredActivity = null" class="score"
                                            :class="[scoreClass(activity.weight != null), { 'highlight-activity': hoveredActivity === gIndex + `-${aIndex + 1}` }]">
                                            <div class="row-center" style="justify-content: center;padding: 0 4px;">
                                                <div style="width: 60%;">
                                                    {{
                                                        formatScore(activity.current_score_view, activity.current_score)
                                                    }}
                                                </div>
                                                <div class="icon-row">
                                                    <img class="icon"
                                                        v-show="activity.navigation_detail.status == 'NeedToResubmit'"
                                                        :src="redoImg" alt="" />
                                                    <img class="icon"
                                                        v-show="(activity.navigation_detail.status == 'NeedToResubmit' || activity.navigation_detail.status == 'Completed') && activity.navigation_detail.has_feedback"
                                                        :src="cmtImg" alt="" />
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                                <tr v-if="lstSemesterTest?.length"
                                    v-for="(testSemester, semesterIndex) in lstSemesterTest"
                                    :key="'testSemester-' + '-' + semesterIndex"
                                    @mouseenter="hoverSemester = 'testSemester-' + '-' + semesterIndex"
                                    @mouseleave="hoverSemester = null"
                                    :class="{ 'highlight-group': hoverSemester === 'testSemester-' + '-' + semesterIndex }"
                                    @click="handleNavigate(testSemester.activities[0]?.navigation_detail)">
                                    <td class="activiti-name" :colspan="2"
                                        :class="{ 'underline': hoverSemester === 'testSemester-' + '-' + semesterIndex }">
                                        {{ testSemester.activities[0]?.activity_name }}
                                    </td>
                                    <td :class="scoreClass(testSemester.activities[0]?.weight != null)" class="score">
                                        <div class="row-center" style="justify-content: center;padding: 0 4px;">
                                            <div style="width: 60%;">
                                                {{
                                                    formatScore(testSemester.activities[0]?.current_score_view,
                                                        testSemester.activities[0]?.current_score)
                                                }}
                                            </div>
                                            <div class="icon-row">
                                                <img class="icon"
                                                    v-show="testSemester.activities[0]?.navigation_detail.status == 'NeedToResubmit'"
                                                    :src="redoImg" alt="" />
                                                <img class="icon"
                                                    v-show="(testSemester.activities[0]?.navigation_detail.status == 'NeedToResubmit' || testSemester.activities[0]?.navigation_detail.status == 'Completed') && testSemester.activities[0]?.navigation_detail.has_feedback"
                                                    :src="cmtImg" alt="" />
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr v-if="participant?.length" v-for="(participantItem) in participant"
                                    :key="'participant' + '-' + participantItem.activities[0]?.activity_id">
                                    <td class="activiti-name" :colspan="2" style="color: #64748B !important;">
                                        {{ participantItem.activities[0]?.activity_name }}
                                    </td>
                                    <td class="score score-green">
                                        <div class="row-center" style="justify-content: left;padding: 0 4px;">
                                            <div>
                                                {{
                                                    formatScore(participantItem.activities[0]?.current_score_view,
                                                        participantItem.activities[0]?.current_score)
                                                }}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </template>

                            <template v-else>
                                <tr>
                                    <td colspan="3">
                                        <div class="no-data">No data found</div>
                                    </td>
                                </tr>
                            </template>
                        </tbody>

                    </table>
                </div>
            </div>
        </div>
        <componentGradebookModal ref="componentGradebookModal">
        </componentGradebookModal>
    </div>
</template>

<script>
import { isMobileDevice } from '@/firebase';
import componentGradebookModal from './componentGradebookModal.vue';
import { getCourseGradebook } from '@/models/grade_book';
import { getModule } from '@/models/dashboard';

export default {
    name: "ScoreTable",
    components: { componentGradebookModal },
    props: ['class_id'],
    data() {
        return {
            closeImg: '/themes/web/assets/images/icon/icon-closed-2.svg',
            redoImg: '/themes/web/assets/images/icon/redo.svg',
            gradebookImg: '/themes/web/assets/images/icon/gradebook.svg',
            cmtImg: '/themes/web/assets/images/icon/comment.svg',
            searchImg: '/themes/web/assets/images/icon/icon-search.svg',
            infoImg: '/themes/web/assets/images/icon/info.svg',
            tooltipItems: [
                {
                    type: 'score',
                    value: '70.86%',
                    color: 'score-green',
                    desc: 'This score is counted to the current or course grade'
                },
                {
                    type: 'score',
                    value: '70.86%',
                    color: 'score-gray',
                    desc: 'This score is not counted to the current or course grade'
                },
                {
                    type: 'icon',
                    icon: '/themes/web/assets/images/icon/redo.svg',
                    desc: 'You are allowed to retry'
                },
                {
                    type: 'icon',
                    icon: '/themes/web/assets/images/icon/comment.svg',
                    desc: 'This activity has some thoughtful feedback'
                }
            ],
            searchText: '',
            showCourseNameTooltip: false,
            showTooltip: false,
            hoveredGroup: null,
            hoveredActivity: null,
            hoverSemester: null,
            courseGradebookData: {},
            lstModules: [],
            lstModulesRaw: [],
            lstSemesterTest: [],
            lstSemesterTestRaw: [],
            isEllipsis: false,
            participant: [],
            participantRaw: null,
            lstModuleForNavigate: [],
            tooltipStyle: null,
        };
    },
    async mounted() {
        window.addEventListener("resize", this.checkEllipsis)
        if (this.$store.getters.isShowMenu) {
            $('.main-content').css({ 'left': '130px' });
        } else {
            $('.main-content').css({ 'left': '50px' });
        }

        await this.getCourseGradebookIpl()
        this.$nextTick(() => {
            this.checkEllipsis()
        })
        await this.getModuleForNavigate()
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.checkEllipsis)
    },
    computed: {
        colWidths() {
            if (isMobileDevice()) {
                return ['30%', '56%', '14%']
            }
            return ['30%', '58%', '12%']
        }
    },
    methods: {
        async goBack() {
            const path = "/subject/" + this.courseGradebookData.course_id + "/" + this.courseGradebookData.class_cms_id;
            return await this.push(path);
        },
        async getCourseGradebookIpl() {
            this.$store.commit("setLoading", true);

            const params = {
                class_id: this.class_id
            };
            return getCourseGradebook(params)
                .then(async (response) => {
                    if (response.data.data?.length) {
                        this.courseGradebookData = response.data.data[0]
                        this.lstModulesRaw = this.courseGradebookData.modules.filter((module) => module.activities[0]?.type_code != 'end_of_semester' && module.activities[0]?.type_code != 'Attendance').map((module) => {
                            return {
                                ...module,
                                module_name: `Module ${module.module_order}: ${module.module_name}`,
                            };
                        });
                        this.lstModules = this.lstModulesRaw
                        this.lstSemesterTestRaw = this.courseGradebookData.modules.filter((module) => module.activities[0]?.type_code == 'end_of_semester')
                        this.lstSemesterTest = this.lstSemesterTestRaw
                        this.participantRaw = this.courseGradebookData.modules.filter((module) => module.activities[0]?.type_code == 'Attendance')
                        this.participant = this.participantRaw
                    }
                    this.$store.commit("setLoading", false);
                })
                .catch(() => {
                    this.$store.commit("setLoading", false);
                    console.log("getCourseGradebook failed, please try again later.");
                });
        },
        checkEllipsis() {
            const el = this.$refs.textEl

            if (el) {
                this.isEllipsis = el.scrollWidth > el.clientWidth
            }
        },
        onSearch() {
            if (this.searchText) {
                this.lstModules = this.lstModulesRaw.reduce((acc, module) => {
                    const filteredActivities = module.activities.filter((a) =>
                        a.activity_name?.toLowerCase().includes(this.searchText.toLowerCase())
                    );

                    if (filteredActivities.length) {
                        acc.push({
                            ...module,
                            activities: filteredActivities,
                        });
                    } else if (module.module_name?.toLowerCase().includes(this.searchText.toLowerCase())) {
                        acc.push(module);
                    }
                    return acc;
                }, []);

                this.lstSemesterTest = this.lstSemesterTestRaw.filter((item) => item.activities[0].activity_name?.toLowerCase().includes(this.searchText.toLowerCase()))

                this.participant = this.participantRaw.filter((item) => item.activities[0].activity_name?.toLowerCase().includes(this.searchText.toLowerCase()))
            }
        },
        openComponentModal() {
            this.$refs.componentGradebookModal.show({
                title: "Component grades",
                courseId: this.courseGradebookData.course_id
            });
        },
        handleTooltip() {
            this.$nextTick(() => {
                const rect = this.$refs.tooltipWrapper.getBoundingClientRect();
                this.tooltipStyle = {
                    position: "fixed",
                    top: rect.bottom - 8 + "px",
                    left: rect.right - 300 + "px"
                };
            });
        },
        handleMouseEnter() {
            if (!isMobileDevice()) {
                this.handleTooltip();
                this.showTooltip = true
            }
        },
        handleMouseLeave() {
            if (!isMobileDevice()) this.showTooltip = false
        },
        handleClick() {
            if (isMobileDevice()) {
                this.handleTooltip();
                this.showTooltip = !this.showTooltip;
                if (this.showTooltip) {
                    document.addEventListener("click", this.handleClickOutside);
                } else {
                    document.removeEventListener("click", this.handleClickOutside);
                }
            }
        },
        handleClickOutside(event) {
            const wrapper = this.$refs.tooltipWrapper;
            if (wrapper && !wrapper.contains(event.target)) {
                this.showTooltip = false;
                document.removeEventListener("click", this.handleClickOutside);
            }
        },
        formatScore(scoreView, score) {
            if (score == null) {
                return '--'
            }
            return (scoreView != 0 ? scoreView.toFixed(2) : 0) + "%";
        },
        scoreClass(isScoreWeight) {
            return isScoreWeight ? "score-green" : "score-gray";
        },
        async handleNavigate(navigationData) {
            if (navigationData.type_code != 'Attendance') {
                if (navigationData.type_code == "assignment" || navigationData.type_code == "end_of_lesson") {
                    const targetRoute =
                        "/lesson/" +
                        navigationData.class_id +
                        "/" +
                        navigationData.course_id +
                        "-" +
                        navigationData.module_id +
                        "-" +
                        navigationData.lesson_id +
                        "-" +
                        navigationData.lesson_package_id +
                        "-" +
                        navigationData.course_item_id +
                        "-" +
                        0;
                    return await this.push(targetRoute);
                }
                return await this.navigateToTestContent(navigationData)
            }
        },
        async getModuleForNavigate() {
            const params = {
                course_id: this.courseGradebookData.course_id,
                class_id: this.courseGradebookData.class_cms_id,
            };

            return getModule(params)
                .then(async (response) => {
                    if (response.data.results) {
                        this.lstModuleForNavigate = response.data.results.modules;
                    }
                })
                .catch(() => {
                    console.log(
                        "getModuleForNavigate failed, please try again later."
                    );
                });
        },
        async navigateToTestContent(navigationData) {
            try {
                let data = navigationData;
                let test = null;

                if (data.type_code === "end_of_semester") {
                    const path = "/subject/" + this.courseGradebookData.course_id + "/" + this.courseGradebookData.class_cms_id;

                    this.$store.dispatch("setCurrentModule", {
                        moduleId: data.course_item_id,
                        courseId: this.courseGradebookData.course_id,
                        classId: this.courseGradebookData.class_cms_id
                    });

                    return await this.$router.push(path);
                }

                if (this.lstModuleForNavigate.length) {
                    test = this.lstModuleForNavigate.find(
                        (module) => module.test?.id == data.test_id
                    )?.test;
                }

                if (!test) {
                    console.log("Cant find test", data);
                    return;
                }

                await this.push({
                    name: "test_detail",
                    query: {
                        test: JSON.stringify(test),
                        type: data.type_code,
                        class_id: data.class_id,
                        course_id: data.course_id,
                        module_id: data.module_id,
                    },
                });
            } catch (err) {
                console.log("Fail navigateToTestContent:", err, navigationData);
            }
        },

        async push(route) {
            return await this.$router.push(route);
        },
    },
    watch: {
        searchText(newVal) {
            if (!newVal || newVal.trim() === '') {
                this.lstModules = this.lstModulesRaw;
                this.lstSemesterTest = this.lstSemesterTestRaw;
                this.participant = this.participantRaw;
            }
        }
    }
};
</script>

<style scoped>
.main-content {
    display: flex;
    flex-direction: column;
    padding: 24px;
    background-color: white;
    border-radius: 24px 0 0 24px;
    height: 100%;
    position: fixed;
    right: 0;
}

.icon-row {
    width: 40%;
    display: flex;
    gap: 4px;
}

.no-data {
    font-size: 16px;
    font-weight: 600;
    color: #A9A9A9;
    text-align: center;
}

.toottip-wrapper {
    position: relative;
}

.table-course-info {
    table-layout: fixed;
}

.ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
}

.tooltip {
    position: absolute;
    left: 60;
    top: 0;
    background: #A9A9A9;
    color: #fff;
    padding: 4px 8px;
    border-radius: 4px;
    white-space: normal;
    z-index: 999;
    font-size: 12px;
    width: 250px;
}

.tooltip-box {
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 1);
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    padding: 16px;
    width: 300px;
    z-index: 1000;
}

.tooltip-item {
    display: flex;
    align-items: center;
    border: 1px solid #A9A9A9;
    border-radius: 8px;
    padding: 8px;
    margin-bottom: 8px;
    width: 100%;
}

.tooltip-item:last-child {
    margin-bottom: 0;
}

.desc {
    font-size: 12px;
    font-weight: 400;
    width: 70%;
}

.title {
    font-size: 32px;
    font-weight: 600;
    color: black;
}

.highlight-group {
    background-color: rgba(31, 39, 129, 0.04);
}

.highlight-activity {
    background-color: rgba(31, 39, 129, 0.04);
}

.activiti-name {
    font-weight: 500;
    color: #0099FF !important;
    font-size: 14px;
}

.underline {
    text-decoration: underline;
}

.row-center {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.score-activity-row {
    padding: 12px;
    background: #CC97EF !important;
    border-radius: 24px 24px 0 0;
    border: 1px solid #F2F2F7;
    border-bottom: none;
}

.score-table {
    width: 100%;
    overflow-x: auto;
}

.score-activity-row .title {
    font-weight: 700;
    font-size: 20px;
    color: white;
}

.score-table table {
    border-collapse: collapse;
    width: 100%;
}

.score-table th,
.score-table td {
    border: 1px solid #F2F2F7;
    padding: 8px;
}

.score-table th {
    background: rgba(204, 151, 239, 0.2);
    text-align: left;
    padding: 8px;
    color: #64748B;
    font-size: 14px;
    font-weight: 700;
}

.score-table td {
    color: black;
}

.group-name {
    font-weight: 600;
    color: #64748B;
    font-size: 14px;
    vertical-align: top;
    width: 250px;
}

.score {
    font-size: 14px !important;
}

.score-green {
    color: #58CC02 !important;
    font-weight: bold;
}

.score-gray {
    color: #A9A9A9 !important;
    font-weight: bold;
}


.gradebook table {
    width: 100%;
    border-collapse: collapse;
    background-color: #f9faff;
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 16px;
}

.gradebook th {
    text-align: center;
    padding: 12px 16px;
    font-weight: 600;
    font-size: 16px;
    color: black;
    background: #F8F9FE;
}

.gradebook td {
    text-align: center;
    padding: 12px 16px;
    font-size: 14px;
    font-weight: 500;
    color: #222;
    background-color: #F8F9FE;
}

.icon {
    width: 20px;
    height: 20px;
}

.search-bar {
    display: flex;
    align-items: center;
    background: white;
    border-radius: 50px;
    overflow: hidden;
    border: 1px solid black;
    box-shadow: 4px 4px black;
}

.search-bar input {
    flex: 1;
    border: none;
    padding: 10px 15px;
    outline: none;
    font-size: 14px;
}

.search-bar input::placeholder {
    opacity: 0.5;
    color: #19171580;
    font-size: 12px;
}

.search-bar input:placeholder-shown+.search-btn {
    background: rgba(31, 39, 129, 0.22);
}

.search-btn:disabled {
    cursor: not-allowed !important;
}

.search-bar input:not(:placeholder-shown)+.search-btn {
    background: #F8FE5F;
}

.search-bar .search-btn {
    border-left: 1px solid black !important;
    border: none;
    padding: 10px 15px;
    cursor: pointer;
    font-size: 16px;
    transition: background 0.3s;
}
</style>
